var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"app-page"},[_c('HomeAddressActions',{attrs:{"dataSource":_vm.dataSource},on:{"onBack":function($event){return _vm.$router.go(-1)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }